import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import Model from "@ckeditor/ckeditor5-ui/src/model";
import Collection from "@ckeditor/ckeditor5-utils/src/collection";
import {
  addListToDropdown,
  createDropdown,
} from "@ckeditor/ckeditor5-ui/src/dropdown/utils";
import EmitterMixin from "@ckeditor/ckeditor5-utils/src/emittermixin";
import mix from "@ckeditor/ckeditor5-utils/src/mix";
import plus from "../assets/icons/plus.svg";
import repoItemIcon from "../assets/icons/repoitem.svg";
import uploadIcon from "../assets/icons/upload.svg";
import trainingIcon from "../assets/icons/online.svg";

class InsertDropdown extends Plugin {
  static get ["pluginName"]() {
    return "Insert Dropdown";
  }
  init() {
    this.editor.ui.componentFactory.add("InsertDropDown", (locale) => {
      const dropdownView = createDropdown(locale);

      dropdownView.buttonView.set({
        type: "button",
        icon: plus,
        class: "add-item-dropdown-button",
      });

      const items = new Collection();

      items.add({
        type: "button",
        model: new Model({
          withText: true,
          label: "Repository Item",
          icon: repoItemIcon,
          id: "repository-item",
          class: "add-item-menu-option",
        }),
      });

      items.add({
        type: "button",
        model: new Model({
          withText: true,
          label: "File",
          icon: uploadIcon,
          id: "file",
          class: "add-item-menu-option",
        }),
      });

      items.add({
        type: "button",
        model: new Model({
          withText: true,
          label: "Link Training",
          icon: trainingIcon,
          id: "link-training",
          class: "add-item-menu-option",
        }),
      });

      addListToDropdown(dropdownView, items);

      dropdownView.on("execute", (eventInfo) => {
        if (eventInfo.source.id === "repository-item") {
          this.editor.fire("addRepositoryItem");
        } else if (eventInfo.source.id === "file") {
          this.editor.fire("addFile");
        } else if (eventInfo.source.id === "link-training") {
          this.editor.fire("linkTraining");
        }
      });

      return dropdownView;
    });
  }
}

mix(InsertDropdown, EmitterMixin);

export default InsertDropdown;
